import axios from "axios";
const serverURL = import.meta.env.VITE_SERVER_URL || (typeof window !== "undefined" && window.location.hostname !== "localhost" ? "https://jeansapi.click2code.com" : "http://localhost:8000");

const getHeaders = (isFormData = false) => {
  const token = sessionStorage.getItem("JeansAdmin") || localStorage.getItem("JeansAdmin");
  const headers = {};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
};

const postData = async (url, body, isFormData = false) => {
  try {
    const response = await axios.post(`${serverURL}/${url}`, body, {
      headers: getHeaders(isFormData),
    });
    return response.data;
  } catch (e) {
    console.error(`Error in postData (${url}):`, e);
    return e?.response?.data || null;
  }
};

const getData = async (url) => {
  try {
    const response = await axios.get(`${serverURL}/${url}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (e) {
    console.error(`Error in getData (${url}):`, e);
    return e?.response?.data || null;
  }
};

export { serverURL, postData, getData };
